import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation CreateMosaicWidget(
    $tenantId: ID!
    $zoneId: ID!
    $input: MosaicWidgetInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          createWidget(input: $input)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.CreateMosaicWidgetMutation,
  undefined,
  graphql.schema.CreateMosaicWidgetMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
